import Grid from "elements/Grid";
import ResourceSlider from "../shared/ResourceSlider";
import Link from "next/link";
import ButtonV2 from "elements/ButtonV2";
import { CMS } from "utils/types";
import { useEffect, useState } from "react";
import NextImage from "next/image";
import { sortByDateDesc } from "../Resources/BlogsPage2";

export const CaseStudies = ({
	caseStudiesType,
}: {
	caseStudiesType: "featured" | "commercial";
}) => {
	const [featuredCaseStudies, setFeaturedCaseStudies] = useState<
		CMS.CMSResource[]
	>([]);
	const [commercialCaseStudies, setCommercialCaseStudies] = useState<
		CMS.CMSResource[]
	>([]);

	useEffect(() => {
		const fetchCaseStudies = async () => {
			try {
				const data = await fetch("/api/case-studies-all");
				const json = await data.json();

				// Check if the response contains an error
				if (json.error) {
					console.error("Error fetching case studies:", json.error);
					return;
				}

				// Check if caseStudies exists in the response
				const caseStudies = json.caseStudies || [];

				setFeaturedCaseStudies(
					caseStudies
						.filter((post: CMS.CMSResource) => post.featured === true)
						.sort(sortByDateDesc)
				);
				setCommercialCaseStudies(
					caseStudies
						.filter((post: CMS.CMSResource) => post.tags.includes("Commercial"))
						.sort(sortByDateDesc)
				);
			} catch (error) {
				console.error("Error fetching case studies:", error);
			}
		};
		fetchCaseStudies();
	}, []);

	if (featuredCaseStudies.length === 0 || commercialCaseStudies.length === 0) {
		return null;
	}

	return (
		<div id="appeals-page-casestudies-posts">
			<Grid>
				<div className="resources-common-grid-divider">
					<div className="appeals-page-casestudies-header">
						<div>
							<h3 className="h3-update">Case Studies</h3>
							<p className="lg denim-medium">
								Real people, real properties, saving&nbsp;real&nbsp;money.
							</p>
						</div>
						<div className="appeals-page-casestudies-btn-hide-on-mobile">
							<Link href="/case-study">
								<ButtonV2 variant="primary-outline">View All</ButtonV2>
							</Link>
						</div>
					</div>
					<ResourceSlider
						swiperID="appeals-page-casestudies-posts"
						resourceData={
							caseStudiesType === "featured"
								? featuredCaseStudies
								: commercialCaseStudies
						}
						type="casestudy"
					/>
				</div>
			</Grid>
		</div>
	);
};
